<template>
  <div>
    Assurance Revenus
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'AssuranceRevenus'
}
</script>
